import type { TimeState } from '../../types/core';
import { wrap } from '../../utils/random';

export function advanceTime(time: TimeState, deltaMinutes: number): TimeState {
  if (time.paused) {
    return time;
  }

  const minutes = time.minuteOfDay + deltaMinutes * time.speed;
  const extraDays = Math.floor(minutes / 1440);

  return {
    ...time,
    day: time.day + extraDays,
    minuteOfDay: wrap(minutes, 1440)
  };
}

export function formatClock(minuteOfDay: number): string {
  const hours = Math.floor(minuteOfDay / 60);
  const minutes = Math.floor(minuteOfDay % 60);
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

export function isNight(minuteOfDay: number): boolean {
  return minuteOfDay < 6 * 60 || minuteOfDay > 20 * 60;
}

export function dayPhase(minuteOfDay: number): 'Dawn' | 'Day' | 'Dusk' | 'Night' {
  if (minuteOfDay < 6 * 60) {
    return 'Night';
  }
  if (minuteOfDay < 8 * 60) {
    return 'Dawn';
  }
  if (minuteOfDay < 19 * 60) {
    return 'Day';
  }
  if (minuteOfDay < 21 * 60) {
    return 'Dusk';
  }
  return 'Night';
}
